import type {BaseQueryApi} from "@reduxjs/toolkit/query";
import {baseQuery} from "../../store/baseQuery";
import {unwrapData} from "../../store/apiResponse";

export type CallChangeKind = 'ONGOING' | 'HISTORY' | 'MISSED';

export interface CallChanges {
    cursor: string;
    changed: CallChangeKind[];
    waitSeconds: number;
}

export interface CallChangesQuery {
    userId: string;
    since?: string;
    wait: number;
}

export type CallChangesStore = Pick<BaseQueryApi, 'dispatch' | 'getState'>;

export const requestCallChanges = async (
    store: CallChangesStore,
    {userId, since, wait}: CallChangesQuery,
    signal: AbortSignal,
): Promise<CallChanges> => {
    const api: BaseQueryApi = {
        dispatch: store.dispatch,
        getState: store.getState,
        signal,
        abort: () => undefined,
        extra: undefined,
        endpoint: 'fetchCallChanges',
        type: 'query',
    };
    const result = await baseQuery({url: '/api/v1/calls/changes', params: {userId, since, wait}}, api, {});
    if (result.error) {
        throw new Error(`Call changes request failed: ${JSON.stringify(result.error)}`);
    }
    return unwrapData(result.data as CallChanges | {data: CallChanges});
};
